module.exports = __webpack_public_path__ + "grey@2x.0308cec7.png";


//////////////////
// WEBPACK FOOTER
// ./src/data/images/grey@2x.png
// module id = rjhU
// module chunks = 0